import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

const iconWeight = 1.6;

export function ThemeToggle() {
  const { setTheme, resolvedTheme: theme } = useTheme();

  return (
    <button onClick={() => setTheme(theme === "light" ? "dark" : "light")}>
      {theme === "light" && (
        <Sun
          className="h-[20px] w-[20px] transition-colors text-brand-gray-400 hover:text-brand-gray-900  dark:text-brand-gray-300 dark:hover:text-brand-gray-100"
          strokeWidth={iconWeight}
        />
      )}
      {theme === "dark" && (
        <Moon
          className="h-[20px] w-[20px] transition-colors text-brand-gray-400 hover:text-brand-gray-900  dark:text-brand-gray-300 dark:hover:text-brand-gray-100"
          strokeWidth={iconWeight}
        />
      )}
    </button>
  );
}
